import React, { useState } from 'react';
import {
  Avatar,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Button,
  Box,
  TextField,
  CircularProgress,
} from '@mui/material';
import Iconify from '../../../../components/iconify';

const DeactivatedMembers = ({
  handleDeactivatedMembersCloseClick,
  deactivatedMembersOpenClick,
  reactivateMemberOpenDialog,
  deactivatedMembers,
  deactivatedMembersLoader,
  deactivatedMembersError,
}) => {
  const [searchTerm, setSearchTerm] = useState('');

  // Filter members based only on last name
  const filteredMembers = deactivatedMembers.filter((member) =>
    member.firstName.toLowerCase().includes(searchTerm.toLowerCase()) ||
    member.lastName.toLowerCase().includes(searchTerm.toLowerCase())
  );


  const isNotFound = searchTerm && filteredMembers.length === 0;

  return (
    <>
      {deactivatedMembersLoader ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
          <CircularProgress size={'1.5rem'} sx={{ color: 'rgba(145, 158, 171, 0.24)' }} />
        </Box>
      ) : (
        <Dialog
          maxWidth={'md'}
          fullWidth
          open={deactivatedMembersOpenClick}
          onClose={handleDeactivatedMembersCloseClick}
          aria-labelledby="deactivatde-member-list-dialogue"
          sx={{ '& .MuiDialog-paper': { width: 800 } }}
        >
          <DialogTitle id="deactivatde-dialog-title">{'Deactivated Members'}</DialogTitle>

          <DialogContent sx={{ height: 500, display: 'flex', flexDirection: 'column' }}>
            {/* Search Input */}
            <TextField
              label="Search by Last Name"
              variant="outlined"
              fullWidth
              margin="normal"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              sx={{
                // change the focus color
                '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#000080',
                },
                // the label color
                '& .MuiInputLabel-outlined.Mui-focused': {
                  color: '#000080',
                },
              }}
            />
            <Paper sx={{ flex: 1, overflow: 'hidden' }}>
              <TableContainer sx={{ maxHeight: '100%', minHeight: 300 }}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Name</TableCell>
                      <TableCell>Gender</TableCell>
                      <TableCell>Type</TableCell>
                      <TableCell>Department</TableCell>
                      <TableCell>Date</TableCell>
                      <TableCell>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {deactivatedMembers.length === 0 ? (
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                          <Paper sx={{ textAlign: 'center' }}>
                            <Typography variant="h6" paragraph>
                              No Deactivated Members
                            </Typography>
                            <Typography variant="body2">
                              There are currently no deactivated members in the system.
                            </Typography>
                          </Paper>
                        </TableCell>
                      </TableRow>
                    ) : filteredMembers.length > 0 ? (
                      filteredMembers.slice().reverse().map((item, index) => (
                        <TableRow key={index}>
                          <TableCell component="th" scope="row">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Avatar src='./fakePath' alt={item.lastName} />
                              <Typography variant="subtitle2" noWrap>
                                {`${item.lastName} ${item.firstName} `}
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell align="left">{item.gender}</TableCell>
                          <TableCell align="left">{item.memberType}</TableCell>
                          <TableCell align="left">{item.department}</TableCell>
                          <TableCell align="left">{'01/01/2025'}</TableCell>
                          <TableCell align="right">
                            <Button
                              sx={{
                                color: '#4B4B8E',
                              }}
                              onClick={() => reactivateMemberOpenDialog(item.memberId)}
                              startIcon={<Iconify icon={'typcn:user-add'} />}
                            >
                              Reactivate
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                          <Paper sx={{ textAlign: 'center' }}>
                            <Typography variant="h6" paragraph>
                              Not found
                            </Typography>
                            <Typography variant="body2">
                              No results found for &quot;{searchTerm}&quot;.
                              <br /> Try checking for typos or using complete words.
                            </Typography>
                          </Paper>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>

                </Table>
              </TableContainer>
            </Paper>
          </DialogContent>

          <DialogActions>
            <Button onClick={handleDeactivatedMembersCloseClick} sx={{ color: '#4B4B8E' }}>
              Close
            </Button>
          </DialogActions>
        </Dialog >
      )}
    </>
  );
};

export default DeactivatedMembers;
